import { COLORS, staticLevelData } from "../constants"
import { useState, useEffect } from "react"
import logo from "../assets/images/logo.png"
import {
    Modal,
    ChooseLevelCard,
    CustomButton,
    ChooseGameCard,
} from "../components"
import styled from "styled-components"
import axios from "axios"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import {
    PDFDownloadLink,
    Document,
    Page,
    View,
    Text,
    BlobProvider,
    StyleSheet,
    Image,
    Font
}
    from '@react-pdf/renderer';

const StyledCircle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.bgColor};
    width: 60px;
    height: 60px;
    border-radius: 50%;
    color:  ${props => props.color};
`;
const colors = [
    {
        bgColor: COLORS.level_one,
        color: COLORS.level_one_text
    },
    {
        bgColor: COLORS.level_two,
        color: COLORS.level_two_text
    },
    {
        bgColor: COLORS.level_three,
        color: COLORS.level_three_text
    },
    {
        bgColor: COLORS.level_four,
        color: COLORS.level_four_text
    },
    {
        bgColor: COLORS.level_five,
        color: COLORS.level_five_text
    },
    {
        bgColor: COLORS.level_six,
        color: COLORS.level_six_text
    }
]
const styles = StyleSheet.create({
    page: {
        fontFamily: 'Fredoka One',
        fontSize: 13,
        paddingTop: 30,
        paddingLeft: 60,
        paddingRight: 60,
        lineHeight: 1.5,
        flexDirection: 'column',
    },
    logo: {
        width: '170px',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    section: {
        marginTop: 10
    },
    input: {
        backgroundColor: '#f2f2f2',
        borderColor: '#d1d1d1',
        borderStyle: 'solid',
        borderWidth: 3,
        height: 40,
        borderRadius: 10,
        width: "50%",
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 10,
        justifyContent: 'center',
        paddingLeft: 10
    },
    circle: {
        backgroundColor: COLORS.green,
        borderRadius: "50%",
        width: 20,
        height: 20,
        color: COLORS.text_dark_green,
        justifyContent: 'center',
        alignItems: 'center'

    }
});
function MyDoc({ levelno, gameno, withAnswers }) {
    const [data, setData] = useState([])
    const api = process.env.REACT_APP_API_URL;
    useEffect(() => {
        axios.get(`${api}/qt/questions/${levelno}/${gameno}`, {}, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(res => {
            const result = res.data;
            setData(result);


        }).catch(error => {
            console.log(error);
        });
    }, [])
    return (
        <Document>
            <Page style={styles.page}>
                <View style={{ textAlign: 'center' }}>
                    <Image style={styles.logo} src={logo} />
                    <Text style={{ color: COLORS.text_green, fontSize: 16 }}>Level {levelno} • Game {gameno}</Text>
                </View>
                <View style={{ display: 'flex', flexDirection: 'row', width: '100%', marginTop: 20 }}>
                    <Text style={{ width: "50%" }}>Name: .....................................................</Text>
                    <Text style={{ width: "50%" }}>Date: .....................................................</Text>
                </View>
                <View style={{ marginTop: 20 }}>
                    {data.map((entry, i) => {
                        return (
                            <View key={i} style={styles.section}>

                                <View style={styles.circle}>
                                    <Text style={{ fontSize: 13 }}>{i + 1}</Text>
                                </View>
                                <Text style={{ color: COLORS.text_green, textAlign: "center", marginTop: "-17" }}>{entry.type} • {entry.word.length} Letters • first letter is {entry.word.charAt(0).toUpperCase()}</Text>

                                <Text style={{ textAlign: "center" }}>{entry.clue}</Text>
                                <View style={styles.input}>
                                    {withAnswers && <Text style={{ textAlign: "center" }}>{entry.word}</Text>}

                                </View>
                            </View>
                        )
                    })}
                </View>
            </Page>
        </Document>
    );
}
export function SelectTrialGamesModal({ modalVisible, onClose, containerheight, gameplay }) {
    const history = useHistory();
    const user = useSelector(state => state.auth.user);
    // const [gameQuestions, setGameQuestions] = useState([]);
    // const api = process.env.REACT_APP_API_URL;
    const handleModalClose = () => {
        onClose()
    }
    // useEffect(() => {
    //     generatePdf(1, 1, false);
    // }, [])

    // const generatePdf = (levelno, gameno, withAnswers) => {

    //     axios.get(`${api}/qt/questions/${levelno}/${gameno}`, {}, {
    //         headers: {
    //             'Accept': 'application/json'
    //         }
    //     }).then(res => {
    //         const result = res.data;
    //         setGameQuestions(result);


    //     }).catch(error => {
    //         console.log(error);
    //     });

    // }
    return (
        <Modal modalVisible={modalVisible} onClose={handleModalClose}
            containerheight={containerheight}>

            <h5 className="color-orange text-center">Choose Level</h5>
            <div className="d-flex flex-wrap">
                {[...Array(6)].map((e, i) => {

                    return <ChooseLevelCard style={{ paddingTop: 20, paddingBottom: 20 }} key={i}>
                        <StyledCircle bgColor={colors[i].bgColor} color={colors[i].color}>
                            <h2 className="mb-0">{i + 1}</h2>
                        </StyledCircle>
                        <h5 className="mt-2 mb-0">Level {i + 1}</h5>
                        <span className="color-text-grey mt-1 mb-1" style={{ fontSize: 13 }}>1st game of the level</span>
                        {user.user_role != 2 &&
                            <CustomButton bgColor={COLORS.green} color={COLORS.text_dark_green} hover={COLORS.darker_green} style={{ height: 40, fontSize: 15, width: 150 }} onClick={() => {
                                if (gameplay) {
                                    window.location.replace(`/test_game/${i + 1}/ref?id=V6iBTipO822O`)
                                } else {
                                    history.replace(`/test_game/${i + 1}/ref?id=V6iBTipO822O`)
                                }
                            }}>Play</CustomButton>}

                        <CustomButton className="mt-2" bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} style={{ height: 40, fontSize: 15, width: 150 }} onClick={() => window.location.replace(`/practice/${i + 1}/1?ref=trial`)}>Practice</CustomButton>
                        {user.user_role == 2 &&
                            <BlobProvider document={<MyDoc levelno={i + 1} gameno={1} withAnswers={false} />}>
                                {({ url }) => (
                                    <a href={url} target="_blank">
                                        <CustomButton bgColor={COLORS.level_six} color={COLORS.level_six_text} hover='#DDC600' className="px-3 mt-2" style={{ height: 40, fontSize: 15, width: 150 }}>
                                            Worksheet
                                        </CustomButton>
                                    </a>
                                )}
                            </BlobProvider>}

                    </ChooseLevelCard>
                })}

            </div>
        </Modal>
    )
}
